// AtmBanking.jsx

import React from "react";
import "../styles/AtmBanking.css";
import {
    FaMapMarkerAlt,
    FaPhoneAlt,
    FaMoneyBillWave,
    FaUniversity,
    FaShieldAlt,
    FaCheckCircle
} from "react-icons/fa";

const branches = [
    {
        name: "Vitthalwadi Branch",
        address: "446, Jagannath, ShankarSeth Road Chira Bazaar, Mumbai - 400002",
        phone: "022-22425589",
        ifsc: "SAH003",
        atm: true,
        map: "https://www.google.com/maps/place/The+Sahayadri+Sahakari+Bank+Ltd/@18.9485211,72.8249326,19.98z/data=!4m6!3m5!1s0x3be7ce18da8bf2b1:0x122b1e36c44af0b4!8m2!3d18.9485459!4d72.8254413!16s%2Fg%2F11clvn14hq?entry=tts"
    },
    {
        name: "Kandivali Branch",
        address: "Sahyadri Nagar, Charkop, Kandivali West, Mumbai-400069",
        phone: "022-28692529 / 022-28685099",
        ifsc: "SAH005",
        atm: true,
        map: "https://www.google.com/maps/place/The+Sahyadri+Sahakari+Bank+Limited/@19.21073,72.5239214,11z/data=!4m6!3m5!1s0x3be7b6c9c4ed57d9:0xbfd1648dbcc61dc4!8m2!3d19.21073!4d72.828792!16s%2Fg%2F1yg93rfry?entry=ttu&g_ep=EgoyMDI2MDMwMS4xIKXMDSoASAFQAw%3D%3D"
    },
    {
        name: "Satara Branch",
        address: "Seven Star Building, Ravivar Peth, Satara-415001",
        phone: "02162-232105 / 02162-232106",
        ifsc: "SAH006",
        atm: true,
        map: "https://www.google.com/maps/place/7+Star+Mall/@17.6919843,74.0031636,18.51z/data=!4m6!3m5!1s0x3bc239bfc4482cbf:0x5e9bc0d5e90fedd4!8m2!3d17.6918405!4d74.0041923!16s%2Fg%2F11hbkzn52_?entry=tts"
    },
    {
        name: "Bhiwandi Branch",
        address: "Haridhara Shopping Complex Anjur Phata Bhiwandi-421302",
        phone: "02522-278833 / 02522-278882",
        ifsc: "SAH008",
        atm: true,
        map: "https://www.google.com/maps/place/The+Sayadri+Sahakari+Bank+Bhiwandi/@19.2733882,73.0422636,20.68z/data=!4m6!3m5!1s0x3be7bdad62352259:0x196c84f2e5888f3e!8m2!3d19.2734625!4d73.0424554!16s%2Fg%2F11clvvr5_d?entry=tts"
    }
];

function AtmBanking() {
    return (
        <div className="atm-wrapper">

            {/* HERO */}
            <section className="atm-hero">
                <h1>ATM Banking Services</h1>
                <p>24/7 Secure & Convenient Banking at Your Nearest ATM</p>
            </section>

            {/* ATM LOCATIONS (Moved Up) */}
            <section className="atm-locations">
                <h2>Find Our ATM Locations</h2>

                <div className="atm-grid">
                    {branches.map((b, i) => (
                        <div className="atm-card" key={i}>

                            <h3>{b.name}</h3>

                            <p>
                                <FaMapMarkerAlt className="icon" />
                                {b.address}
                            </p>

                            <p>
                                <FaPhoneAlt className="icon" />
                                {b.phone}
                            </p>

                            <p>
                                <strong>ATM ID:</strong> {b.ifsc}
                            </p>

                            <a
                                href={b.map}
                                target="_blank"
                                rel="noreferrer"
                                className="atm-direction-btn"
                            >
                                Locate ATM
                            </a>
                        </div>
                    ))}
                </div>
            </section>

            {/* SERVICES */}
            <section className="atm-services">
                <h2>ATM Services Available</h2>

                <div className="atm-services-grid">
                    <div className="atm-service-card">
                        <FaMoneyBillWave />
                        <h4>Cash Withdrawal</h4>
                    </div>

                    <div className="atm-service-card">
                        <FaUniversity />
                        <h4>Balance Enquiry</h4>
                    </div>

                    <div className="atm-service-card">
                        <FaUniversity />
                        <h4>Mini Statement</h4>
                    </div>

                    <div className="atm-service-card">
                        <FaShieldAlt />
                        <h4>PIN Change</h4>
                    </div>
                </div>
            </section>

            {/* SAFETY */}
            <section className="atm-safety">
                <h2>ATM Safety Guidelines</h2>

                <div className="atm-safety-grid">
                    <div className="safety-card">
                        <FaCheckCircle />
                        <p>Do not share your PIN with anyone</p>
                    </div>

                    <div className="safety-card">
                        <FaCheckCircle />
                        <p>Cover keypad while entering PIN</p>
                    </div>

                    <div className="safety-card">
                        <FaCheckCircle />
                        <p>Avoid assistance from strangers</p>
                    </div>

                    <div className="safety-card">
                        <FaCheckCircle />
                        <p>Collect your card before leaving</p>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default AtmBanking;